// CFA2 question-bank numbering helpers, shared by the 2026 (views/CFA2-2025) and
// 2027 (views/CFA2-2027) Cfa2chapter.js pages.
//
// question_number can have gaps: inactive / admin-deleted questions keep their number
// but are not in the case's active list (the LMS reads questions by case_id + isActive2025).

// The requested number if the case has it, otherwise the case's first active question's number.
export const resolveQuestionNumber = (questions, wanted) => {
  for (let i = 0; i < questions.length; i++) {
    // eslint-disable-next-line eqeqeq
    if (questions[i].question_number == wanted) return wanted;
  }
  return questions.length ? questions[0].question_number : wanted;
};

// Number shown to the user: position among the case's active questions (offset + 1), so gaps
// don't show (the first active question is always 1). Falls back to the stored number while
// no question is selected yet.
export const questionDisplayNumber = (question, offset) =>
  offset === '' || offset === null || offset === undefined
    ? question.question_number
    : Number(offset) + 1;



// WEBPACK FOOTER //
// ./src/common/cfa2QuestionNumbering.js